const filters = {
  btnFilters: 'Filters',
  titleDropdown: 'Quick filters',

  filterDate: {
    today: 'Today',
    tomorrow: 'Tomorrow',
    yesterday: 'Yesterday',
    lastWeek: 'Last Week',
    lastMonth: 'Last Month',
    customRange: 'Custom Range',
    overLimit: 'Please select a range of {{limit}} days or less',
    
    fromTime: 'From Time',
    toTime: 'To Time',
  },
};

export default filters;
